// extracted by mini-css-extract-plugin
export default {"card":"WXnTm2xa","content":"drVBe3A9"};